import { inject, Injectable, signal } from '@angular/core';
import { API_ROUTES } from 'src/utils/apiRoutes';
import { ApiService } from 'src/utils/apiService';
import { DocumentType, Month } from '../interfaces/certificados-model';
import { responseDAO } from '../interfaces/requests.dao';
import { toObservable } from '@angular/core/rxjs-interop';
import { AlertService } from './alert.service';
import { AlertMessageService } from '@app/module-admin/administrator/services/alert-message.service';
import { AlertApiResponseSchema, OfficesApiResponseSchema, MappedOffice, Office } from '../schemas';

@Injectable({
  providedIn: 'root'
})
export class InicializerService {

  private alertService = inject(AlertService)
  private apiService = inject(ApiService)
  private configurationsService = inject(AlertMessageService);

  private documentType = signal<DocumentType[]>([])
  private listOffices = signal<MappedOffice[]>([])
  public listOffices$ = toObservable(this.listOffices)

  private dataAlert = signal({})
  dataAlert$ = toObservable(this.dataAlert)

  //INICIALIZADOR DE LOS TIPOS DE DOCUMENTO.
  inicializeDocumentTypes() {
    let documentTypes: DocumentType[] = [];
    let documentType: DocumentType;
    documentType = {
      idDT: 1,
      nameDT: "CÉDULA DE CIUDADANÍA",
      abbreviationDT: "CC",
      value: "CedulaDeCiudadania"
    }
    documentTypes.push(documentType);
    documentType = {
      idDT: 2,
      nameDT: "TARJETA DE IDENTIDAD",
      abbreviationDT: "TI",
      value: "TarjetaDeIdentidad"
    }
    documentTypes.push(documentType);
    documentType = {
      idDT: 3,
      nameDT: "PASAPORTE",
      abbreviationDT: "PA",
      value: "Pasaporte"
    }
    documentTypes.push(documentType);
    documentType = {
      idDT: 4,
      nameDT: "NIT",
      abbreviationDT: "NIT",
      value: "NIT"
    }
    documentTypes.push(documentType);
    //Devolvemos el listado con los diferentes tipos de documentos.
    return documentTypes;
  };

  //INICIALIZADOR DE LAS OFICINAS.
  inicializeOffices() {
    return this.apiService.get<responseDAO>(API_ROUTES.public.routes.offices)
      .subscribe({
        next: (response) => {
          const validation = OfficesApiResponseSchema.safeParse(response);
          if (!validation.success) {
            console.warn('[Offices] El contrato de respuesta no se cumple:', validation.error.format());
          }
          
          const listOffices: MappedOffice[] = (response.data || []).map((item: Office) => {
            return {
              ...item,
              idOff: item.id_office,
              itemValue: item.value,
              nameOff: item.description,
              valueOff: item.value
            };
          });
          this.listOffices.set(listOffices)
        },
        error: (error) => {
          let message = error.error?.error?.message || 'Ha ocurrido un error, intenta de nuevo mas tarde'
          this.alertService.alert('error', `${message}`)
        }
      });
  };

  allMonths() {
    let months: Month[] = [
      { value: '01', name: 'Enero' },
      { value: '02', name: 'Febrero' },
      { value: '03', name: 'Marzo' },
      { value: '04', name: 'Abril' },
      { value: '05', name: 'Mayo' },
      { value: '06', name: 'Junio' },
      { value: '07', name: 'Julio' },
      { value: '08', name: 'Agosto' },
      { value: '09', name: 'Septiembre' },
      { value: '10', name: 'Octubre' },
      { value: '11', name: 'Noviembre' },
      { value: '12', name: 'Diciembre' }
    ]
    return months;
  };

  inicializeAlertActive() {
    return this.configurationsService.getConfigurationById(1)
    .subscribe({
        next: (response) => {
          const result = AlertApiResponseSchema.safeParse(response);
          if (!result.success) {
            console.warn('[Alert] El contrato de respuesta no se cumple:', result.error.format());
          }
          this.dataAlert.set(response.data);
        },
        error: (error) => {
          let message = error.error?.error?.message || 'Ha ocurrido un error, intenta de nuevo mas tarde'
          this.alertService.alert('error', `${message}`)
        }
      });
  };
}
